/** 
 * Returns the total padding (left + right) of the box model for a given HTML element.
 * @param {HTMLElement} element - The HTML element to calculate the padding for.
 * @returns {number} The total padding of the box model.
*/
export function getTotalPaddingOfBoxModel(element: HTMLElement): number {
    const styles = window.getComputedStyle(element);
    const paddingLeft = parseFloat(styles.paddingLeft) || 0;
    const paddingRight = parseFloat(styles.paddingRight) || 0;
    
    const totalPaddingOfBoxModel = paddingLeft + paddingRight;
    
    return totalPaddingOfBoxModel;
}

/**
 * Returns the total margin (left + right) of the box model for a given HTML element.
 * @param {HTMLElement} element - The HTML element to calculate the margin for.
 * @returns {number} The total margin of the box model.
 */
export function getTotalMarginOfBoxModel(element: HTMLElement): number {
    const styles = window.getComputedStyle(element);
    const marginLeft = parseFloat(styles.marginLeft) || 0;
    const marginRight = parseFloat(styles.marginRight) || 0;
    
    const totalMarginOfBoxModel = marginLeft + marginRight;
    
    return totalMarginOfBoxModel;
}

/**
 * Returns the total spacing (padding + margin) of the box model for a given HTML element.
 * @param {HTMLElement} element - The HTML element to calculate the total spacing for.
 * @returns {number} The total spacing of the box model.
 */
export function getTotalSpacingOfBoxModel(element: HTMLElement): number {
    const totalPaddingOfBoxModel = getTotalPaddingOfBoxModel(element);
    const totalMarginOfBoxModel = getTotalMarginOfBoxModel(element);
    
    const totalSpacingOfBoxModel = totalPaddingOfBoxModel + totalMarginOfBoxModel;
    
    return totalSpacingOfBoxModel;
}

/**
 * Returns the total width of the box model (element width + total spacing) for a given HTML element.
 * @param {HTMLElement} element - The HTML element to calculate the total width for.
 * @returns {number} The total width of the box model.
 */
export function getTotalWidthOfBoxModel(element: HTMLElement): number {
    const elementWidth = element.offsetWidth;
    const totalMarginOfBoxModel = getTotalMarginOfBoxModel(element);
    
    const totalWidthOfBoxModel = elementWidth + totalMarginOfBoxModel;
    
    return totalWidthOfBoxModel;
}